export class NoticeDto {
    id: string;
    component: string;
    level: string;
    title: string;
    description: string;
    infoUrl: string;
    readed: boolean;
    show: boolean;

    constructor(level: string, title: string, description: string, infoUrl: string) {
        this.level = level;
        this.title = title;
        this.description = description;
        this.infoUrl = infoUrl;
    }

}
